import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs.js";
import type { ReactNode } from "react";

export type LocaleKey = "it" | "en" | "de";
export const LOCALE_KEYS: LocaleKey[] = ["it", "en", "de"];
const LABEL: Record<LocaleKey, string> = { it: "Italiano", en: "English", de: "Deutsch" };

type Props = {
  value: LocaleKey;
  onValueChange: (next: LocaleKey) => void;
  render: (locale: LocaleKey) => ReactNode;
};

export function I18nFieldTabs({ value, onValueChange, render }: Props): JSX.Element {
  return (
    <Tabs value={value} onValueChange={(v) => onValueChange(v as LocaleKey)}>
      <TabsList>
        {LOCALE_KEYS.map((k) => (
          <TabsTrigger key={k} value={k} aria-label={LABEL[k]}>{k}</TabsTrigger>
        ))}
      </TabsList>
      {LOCALE_KEYS.map((k) => (
        <TabsContent key={k} value={k}>{render(k)}</TabsContent>
      ))}
    </Tabs>
  );
}
